import React from 'react';
import { Provider } from 'react-redux';
import { Router, Route, browserHistory } from 'react-router';
import App from '../containers/App/App';
import Dashboard from '../containers/Dashboard';
import HelpPage from '../components/HelpPage';
import BuyPage from '../components/BuyPage';
import PassesIndex from '../containers/Passes';
import Event from '../containers/Event';
import RequestCredential from '../containers/Request';
import SeasonForm from '../components/RequestForm/SeasonForm';
import SeasonPaddockForm from '../components/RequestForm/SeasonPaddockForm';
import SeasonMediaForm from '../components/RequestForm/SeasonMediaForm';
import VIPGuestForm from '../components/RequestForm/VIPGuestForm';
import PaddockGuestWristbandForm from '../components/RequestForm/PaddockGuestWristbandForm';
import BroadcastGuestWristbandForm from '../components/RequestForm/BroadcastGuestWristbandForm';
import VendorGuestWristbandForm from '../components/RequestForm/VendorGuestWristbandForm';
import ModelForm from '../components/RequestForm/ModelForm';
import VIPSingleForm from '../components/RequestForm/VIPSingleForm';
import WorkingSingleForm from '../components/RequestForm/WorkingSingleForm';
import MediaSingleForm from '../components/RequestForm/MediaSingleForm';
import HotpitForm from '../components/RequestForm/HotpitForm';
import {requireAuth, checkLoggedIn} from '../utils';

const Root = ({ store }) => (
  <Provider store={store}>
    <Router history={browserHistory}>
      <Route path="/" component={App} onEnter={checkLoggedIn} />
      <Route path="dashboard" component={Dashboard} onEnter={requireAuth} />
      <Route path="credentials/(:type)-passes" component={PassesIndex} onEnter={requireAuth} />
      <Route path="request" component={RequestCredential} onEnter={requireAuth} />
      <Route path="request-form-season(/:credentialId)" component={SeasonForm} onEnter={requireAuth} />
      <Route path="request-form-season-paddock(/:credentialId)" component={SeasonPaddockForm} onEnter={requireAuth} />
      <Route path="request-form-season-media(/:credentialId)" component={SeasonMediaForm} onEnter={requireAuth} />
      <Route path="request-form-vip-guest(/:credentialId)" component={VIPGuestForm} onEnter={requireAuth} />
      <Route path="request-form-paddock-guest-wristband(/:credentialId)" component={PaddockGuestWristbandForm} onEnter={requireAuth} />
      <Route path="request-form-broadcast-guest-wristband(/:credentialId)" component={BroadcastGuestWristbandForm} onEnter={requireAuth} />
      <Route path="request-form-vendor-guest-wristband(/:credentialId)" component={VendorGuestWristbandForm} onEnter={requireAuth} />
      <Route path="request-form-model(/:credentialId)" component={ModelForm} onEnter={requireAuth} />
      <Route path="request-form-vip-single(/:credentialId)" component={VIPSingleForm} onEnter={requireAuth} />
      <Route path="request-form-working-single(/:credentialId)" component={WorkingSingleForm} onEnter={requireAuth} />
      <Route path="request-form-media-single(/:credentialId)" component={MediaSingleForm} onEnter={requireAuth} />
      <Route path="request-form-hotpit-guest(/:credentialId)" component={HotpitForm} onEnter={requireAuth} />
      <Route path="help" component={HelpPage} onEnter={requireAuth} />
      <Route path="buy" component={BuyPage} onEnter={requireAuth} />
      <Route path="/event/:id" component={Event} onEnter={requireAuth} />
    </Router>
  </Provider>
);

export default Root;



// WEBPACK FOOTER //
// ./src/components/root.js